import React from "react";
import StartEncounterComponent from "components/community/StartEncounter";
const StartEncounter = () => {
  return (
    <>
      <div className="main-contents">
        <StartEncounterComponent />
      </div>
    </>
  );
};

export default StartEncounter;
